import API from "./api";

// 🔐 LOGIN
export const login = async (username, password) => {
    try {
        const payload = { username, password };

        const response = await API.post("/Auth/login", payload);

        // ✅ store user
        localStorage.setItem("user", JSON.stringify(response.data));

        return response.data;

    } catch (error) {
        console.error("LOGIN ERROR:", error.response?.data || error.message);

        // ✅ safer error message handling
        const message =
            error.response?.data?.message ||
            error.response?.data ||
            "Login failed";

        throw message;
    }
};

export const changePassword = async (data) => {

    const response = await API.post(
        "/Auth/change-password",
        data
    );

    return response.data;
};

// 🚪 LOGOUT
export const logout = () => {
    localStorage.removeItem("user");
};

// 👤 GET CURRENT USER
export const getCurrentUser = () => {
    try {
        const user = localStorage.getItem("user");
        return user ? JSON.parse(user) : null;
    } catch {
        return null; // ✅ prevents crash if corrupted data
    }
};